module.exports = __webpack_public_path__ + "static/media/user.769871e5.svg";